import React, { useState, useEffect } from "react";
import { Accordion, Button, Badge } from "react-bootstrap";
import Layout from "../components/layout";
import SEO from "../components/seo";

const ReadingMaterial = () => {
  const [readingMaterialData, setReadingMaterialData] = useState([]);

  useEffect(() => {
    // Fetch the JSON data from the static folder
    fetch("/reading-material-list.json")
      .then(response => response.json())
      .then(data => setReadingMaterialData(data))
      .catch(error =>
        console.error("Error fetching reading material data:", error)
      );
  }, []); // Empty dependency array ensures this runs once on mount

  return (
    <React.Fragment>
      <Layout pageInfo={{ pageName: "Reading Material" }}>
        <SEO title="Reading Material" />

        {readingMaterialData.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            {section.header && <h4>{section.header}</h4>}
            <Accordion>
              {section.subsections ? ( // Handle nested accordions (Post Graduate)
                section.subsections.map((subsection, subsectionIndex) => (
                  <Accordion.Item
                    eventKey={`${sectionIndex}-${subsectionIndex}`}
                    key={`${sectionIndex}-${subsectionIndex}`}
                  >
                    <Accordion.Header>{subsection.header}</Accordion.Header>
                    <Accordion.Body>
                      {subsection.files.map((file, fileIndex) => (
                        <p key={fileIndex}>
                          <Button
                            variant="outline-dark"
                            size="sm"
                            href={`/documents/reading-material/${subsection.directory}/${file.filename}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {file.title} <Badge bg="secondary">{file.type}</Badge>
                          </Button>
                        </p>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                ))
              ) : ( // Handle single-level accordions (Misc., Ph.D.)
                <Accordion.Item eventKey={sectionIndex.toString()}>
                  <Accordion.Header>{section.header}</Accordion.Header>
                  <Accordion.Body>
                    {section.files && section.files.map((file, fileIndex) => (
                      <p key={fileIndex}>
                        <Button
                          variant="outline-dark"
                          size="sm"
                          href={`/documents/reading-material/${section.directory}/${file.filename}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {file.title} <Badge bg="secondary">{file.type}</Badge>
                        </Button>
                      </p>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              )}
            </Accordion>
            <br></br> {/* Add spacing between main sections */}
          </div>
        ))}

        <hr />
      </Layout>
    </React.Fragment>
  );
};

export default ReadingMaterial;